import { render, staticRenderFns } from "./class-record-detail.vue?vue&type=template&id=61e323e4&scoped=true"
import script from "./class-record-detail.vue?vue&type=script&lang=js"
export * from "./class-record-detail.vue?vue&type=script&lang=js"
import style0 from "./class-record-detail.vue?vue&type=style&index=0&id=61e323e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e323e4",
  null
  
)

export default component.exports